import { locatorServiceAPI } from 'shared/services';

import  { DimensionLimitation } from '../types';

export const dimensionsAPI = {
  getDimensionsLimitation: () => locatorServiceAPI.get<DimensionLimitation[]>('dimensions-limitation')
};
